<template>
  <b-modal
    :visible="visible"
    hide-footer
    button-size="sm"
    size="xl"
    modal-cancel="false"
    no-close-on-backdrop
    @close="close"
    id="courses-syllabus-list"
  >
    <template v-slot:modal-title>Lista de cursos</template>
    <section class="container-fluid">
      <div class="row mb-1">
        <div class="col-6">
          <template v-if="syllabus !== null">
            <span>
              <b>Pensum:</b>
              {{ syllabus.description }}</span
            >
            <span> <b>Versión:</b> {{ syllabus.version }}</span>
          </template>
        </div>
        <div class="col-6 text-right">
          <button
            class="card-header-action btn btn-sm btn-success"
            @click="modalAddCourseSyllabus"
          >
            <CIcon size="sm" name="cil-plus" />
          </button>
        </div>
      </div>
      <CDataTable
        class="table-bordered c-table c-table-main"
        :hover="true"
        :striped="true"
        :bordered="true"
        :small="true"
        :items="items"
        :fields="fields"
        :sorter="{ external: true, resetable: true }"
        @update:sorter-value="filterTable"
        :columnFilter="{ external: true, lazy: true }"
        @update:column-filter-value="filterTable"
        :column-filter-value.sync="columnFilter"
        :loading="loading"
      >
        <template #no-items-view>
          <div class="no-items-view">
            {{
              loading
                ? "Cargando datos..."
                : "No existen programas de cursos registrados"
            }}
            <CIcon name="cil-ban" size="xl" v-if="!loading"></CIcon>
          </div>
        </template>
        <!-- filters -->
        <template #course_id-filter>
          <v-select
            label="name"
            :options="optionsCourses"
            :reduce="(course) => course.id"
            id="course_id"
            v-model="columnFilter.course_id"
            @search="onSearchCourses"
            @input="filterTable"
          >
            <template slot="no-options">Buscar</template>
          </v-select>
        </template>
        <template #syllabus_id-filter>
          <v-select
            label="description"
            :options="optionsSyllabus"
            :reduce="(syllabus) => syllabus.id"
            id="syllabus_id"
            v-model="columnFilter.syllabus_id"
            @search="onSearchSyllabus"
            @input="filterTable"
          >
            <template slot="no-options">Buscar</template>
          </v-select>
        </template>
        <template #enabled-filter>
          <v-select
            :options="enabledOptions"
            label="label"
            :reduce="(enabledOption) => enabledOption.code"
            v-model="columnFilter.enabled"
            @input="filterTable"
          ></v-select>
        </template>
        <template #detail-filter>
          <b-button
            @click="reload"
            variant="secondary"
            size="sm"
            title="Recargar tabla"
          >
            <CIcon size="sm" name="cil-reload" />
          </b-button>
          <b-button
            @click="clean"
            variant="secondary"
            size="sm"
            title="Limpiar filtros"
          >
            <CIcon size="sm" name="cil-filter-x" />
          </b-button>
        </template>
        <!-- data -->
        <template #id="{ index }">
          <td>{{ (page - 1) * limit + (index + 1) }}</td>
        </template>
        <template #course_id="{ item }">
          <td>
            {{ item.course ? item.course.name : "" }}
          </td>
        </template>
        <template #syllabus_id="{ item }">
          <td>
            {{ item.syllabus ? item.syllabus.description : "" }}
          </td>
        </template>
        <template #enabled="{ item }">
          <td>
            <CBadge color="success" v-if="item.enabled == true">Activo</CBadge>
            <CBadge color="danger" v-else>Inactivo</CBadge>
          </td>
        </template>

        <template #detail="{ index, item }">
          <td>
            <b-button-group size="xs">
              <b-button
                v-if="(page - 1) * limit + (index + 1) != 1"
                @click="updatePosition(item.id, 'up')"
                variant="info"
                title="Subir posición"
              >
                <CIcon size="sm" name="cil-arrow-thick-top" />
              </b-button>
              <b-button
                @click="updatePosition(item.id, 'down')"
                variant="info"
                title="Bajar posición"
              >
                <CIcon size="sm" name="cil-arrow-thick-bottom" />
              </b-button>
              <b-button
                @click="modalEditCourseSyllabus(item.id)"
                variant="warning"
                title="Editar"
              >
                <CIcon size="sm" name="cil-pencil" />
              </b-button>
              <b-button
                @click="modalDelete(item.id)"
                variant="danger"
                title="Eliminar"
              >
                <CIcon size="sm" name="cil-trash" />
              </b-button>
            </b-button-group>
          </td>
        </template>
      </CDataTable>
      <div>
        <CPagination
          :activePage.sync="page"
          :pages="pages"
          size="sm"
          align="center"
          @update:activePage="updateTable"
        />
        <TableRecords
          :total="total"
          :loading="loading"
          :from="from"
          :to="to"
          :page="page"
        />
      </div>
      <section v-if="modShowCourseSyllabus">
        <CourseSyllabusDeleteModal
          :course_syllabus_id="course_syllabus_id"
          :modShowCourseSyllabus="modShowCourseSyllabus"
          @CourseSyllabusDeleteModal="afterDeleteCourseSyllabus"
        ></CourseSyllabusDeleteModal>
      </section>
      <section v-if="modShowCourseSyllabusAdd">
        <CourseSyllabusAddModal
          :syllabus_id="syllabus_id"
          :modShowCourseSyllabusAdd="modShowCourseSyllabusAdd"
          @courseSyllabusAddModal="afterAddCourseSyllabus"
        ></CourseSyllabusAddModal>
      </section>
      <section v-if="modShowCourseSyllabusEdit">
        <CourseSyllabusEditModal
          :syllabus_id="syllabus_id"
          :course_syllabus_id="course_syllabus_id"
          :modShowCourseSyllabusEdit="modShowCourseSyllabusEdit"
          @courseSyllabusEditModal="afterEditCourseSyllabus"
        ></CourseSyllabusEditModal>
      </section>
    </section>
  </b-modal>
</template>
<script>
import { BAlert, BModal, BButton, BButtonGroup } from "bootstrap-vue";

import TableRecords from "@/components/shared/TableRecords";
import { Utils } from "@/plugins/utils";
import Constants from "@/plugins/constants";
// services
import CoursesSyllabus from "@/plugins/services/courses-syllabus";
import Courses from "@/plugins/services/courses";
import Syllabus from "@/plugins/services/syllabus";

// components
import CourseSyllabusDeleteModal from "@/entities/courses-syllabus/CourseSyllabusDeleteModal.vue";
import CourseSyllabusAddModal from "@/entities/courses-syllabus/CourseSyllabusAddModal";
import CourseSyllabusEditModal from "@/entities/courses-syllabus/CourseSyllabusEditModal";

export default {
  name: "CoursesSyllabusListModal",
  components: {
    BAlert,
    BModal,
    BButton,
    BButtonGroup,
    TableRecords,
    CourseSyllabusDeleteModal,
    CourseSyllabusAddModal,
    CourseSyllabusEditModal,
  },
  props: {
    modShowCoursesSyllabusList: { type: Boolean, required: true },
    syllabus_id: { type: Number, required: true },
  },
  data() {
    return {
      fields: [
        {
          key: "id",
          label: "#",
          sorter: false,
          filter: false,
          _style: "width:8px;",
        },
        {
          key: "course_id",
          label: "Curso",
          _style: "width:60%;",
        },
        {
          key: "position",
          label: "Posición",
          _style: "width:15%;",
          filter: false,
        },
        {
          key: "enabled",
          label: "Estado",
          filter: true,
          _style: "width:15%;",
        },
        {
          key: "detail",
          label: "Acciones",
          sorter: false,
          _style: "width: 110px;",
        },
      ],
      syllabus: null,
      items: [],
      optionsCourses: [],
      optionsSyllabus: [],
      columnFilter: { column: "position", asc: true, enabled: true },
      enabledOptions: Constants.enabledOptions,
      page: 0,
      pages: 0,
      limit: 10,
      from: 0,
      to: 0,
      total: 0,
      loading: true,
      course_syllabus_id: 0,
      modShowCourseSyllabus: false,
      modShowCourseSyllabusAdd: false,
      modShowCourseSyllabusEdit: false,
      dataEmit: { modalShow: false, data: null },
    };
  },
  mounted() {
    this.columnFilter.syllabus_id = this.syllabus_id;
    this.getOneSyllabus(this.syllabus_id);
    this.getAll(this.columnFilter);
  },
  computed: {
    userAuth() {
      return this.$store.state.userAuth;
    },
    visible() {
      return this.modShowCoursesSyllabusList;
    },
  },
  methods: {
    getAll(q = null, page = null) {
      this.loading = true;
      CoursesSyllabus.all(q, this.limit, page).then((res) => {
        this.loading = false;
        this.items = res.data.data;
        this.page = res.data.current_page;
        this.pages = res.data.last_page;
        this.total = res.data.total;
        this.from = res.data.from;
        this.to = res.data.to;
      });
    },
    getOneSyllabus(id) {
      Syllabus.getOne(id)
        .then((res) => {
          this.syllabus = res.data;
        })
        .catch((err) => {
          if (err.response && err.response.status == 404) {
            Utils.setFlash("danger", "Programa de curso no encontrado.");
            this.closeModal();
          }
          if (err.response && err.response.status == 500) {
            Utils.setFlash("danger", "Error de servidor.");
            this.closeModal();
          }
          this.dataLoader = false;
        });
    },
    updateTable(page) {
      this.getAll(this.columnFilter, page);
    },
    filterTable(columnFilter) {
      this.columnFilter = { ...this.columnFilter, ...columnFilter };
      this.getAll(this.columnFilter);
    },
    clean() {
      this.columnFilter = {
        column: "position",
        asc: true,
        enabled: true,
        syllabus_id: this.syllabus_id,
      };
      this.getAll(this.columnFilter);
    },
    reload() {
      this.getAll(this.columnFilter, this.page);
    },
    modalDelete(id) {
      this.modShowCourseSyllabus = true;
      this.course_syllabus_id = id;
    },
    afterDeleteCourseSyllabus(response) {
      if (
        response.data != null ||
        response.status == 404 ||
        response.status == 500
      ) {
        this.reload();
      }
      this.modShowCourseSyllabus = response.modalShow;
    },
    modalAddCourseSyllabus(id) {
      this.modShowCourseSyllabusAdd = true;
    },
    afterAddCourseSyllabus(response) {
      if (
        response.data != null ||
        response.status == 404 ||
        response.status == 500
      ) {
        this.reload();
      }
      this.modShowCourseSyllabusAdd = response.modalShow;
    },
    modalEditCourseSyllabus(id) {
      this.course_syllabus_id = id;
      this.modShowCourseSyllabusEdit = true;
    },
    afterEditCourseSyllabus(response) {
      if (
        response.data != null ||
        response.status == 404 ||
        response.status == 500
      ) {
        this.reload();
      }
      this.modShowCourseSyllabusEdit = response.modalShow;
    },
    onSearchSyllabus(search, loading) {
      if (search.length > 0) {
        loading(true);
        this.getSyllabus(loading, search);
      }
    },
    getSyllabus(loading = null, search = null) {
      Syllabus.selectAll(search)
        .then((res) => {
          this.optionsSyllabus = res.data;
          if (loading != null) {
            loading(false);
          }
        })
        .catch((err) => {
          loading(false);
          console.log(err);
        });
    },
    onSearchCourses(search, loading) {
      if (search.length > 0) {
        loading(true);
        this.getCourses(loading, search);
      }
    },
    getCourses(loading = null, search = null) {
      Courses.selectAll(search)
        .then((res) => {
          this.optionsCourses = res.data;
          if (loading != null) {
            loading(false);
          }
        })
        .catch((err) => {
          loading(false);
          console.log(err);
        });
    },
    updatePosition(id, to) {
      CoursesSyllabus.updatePosition(id, to, this.syllabus_id)
        .then((res) => {
          this.reload();
          Utils.setFlash("success", "Posición modificada correctamente.");
        })
        .catch((err) => {
          console.log(err);
        });
    },
    closeModal(data = null) {
      this.dataEmit.modalShow = false;
      this.dataEmit.data = data;
      this.$emit("coursesSyllabusListModal", this.dataEmit);
    },
    close() {
      this.closeModal();
    },
  },
};
</script>
